import { Card } from '../card';
import { useList } from '../../hooks/useList';
import { ErrorPage } from '@/components/ErrorPage';
import Button from '@/components/Button';
import { SuspenseLoading } from '@/pages/reporting-tools/components/loading';
import { animated } from '@react-spring/web';
import { useAnimatedMissions } from '../../hooks/useAnimatedMissions';

interface MissionListProps {
  headerComponent: () => React.ReactNode;
}

export const MissionList = ({ headerComponent }: MissionListProps) => {
  const { missionsList, errors, hasMore, onFetchMore, isPending } = useList();

  const missions = missionsList?.nodes || [];
  const transitions = useAnimatedMissions(missions);

  if (errors.length > 0) {
    console.error('MissionListScreen', { ...errors });
    return <ErrorPage error="Failed to load missions" />;
  }

  return (
    <div className="flex flex-col items-end">
      {headerComponent()}

      <div className={`relative grid grid-cols-1 gap-4 md:grid-cols-2`}>
        {isPending && missions.length > 0 && <SuspenseLoading className="!h-full" />}
        {transitions((styles, mission) => (
          <animated.div style={styles}>
            <Card key={mission.slug} mission={mission} />
          </animated.div>
        ))}
      </div>
      <div className="relative flex w-full justify-center">
        {isPending && missions.length === 0 && <SuspenseLoading className="!h-full" />}

        {missions.length === 0 && (
          <div className="col-span-2 flex h-full flex-col items-center justify-center rounded-2xl pb-5">
            <p className="text-sh-xs text-gray-500">No missions found</p>
          </div>
        )}
      </div>

      {hasMore && (
        <Button theme="outline" className="mt-4" onClick={onFetchMore}>
          + more
        </Button>
      )}
    </div>
  );
};
